var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSucess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 33498"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 764",
    opacity: 0.1,
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "#4ECA4D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 36C11.66 36 4.5 28.84 4.5 20C4.5 11.16 11.66 4 20.5 4C29.34 4 36.5 11.16 36.5 20C36.5 28.84 29.34 36 20.5 36ZM27.74 14.76C27.26 14.28 26.5 14.28 26.02 14.76L18.38 22.6L14.98 19.08C14.5 18.6 13.74 18.6 13.26 19.08C12.78 19.56 12.78 20.36 13.26 20.84L17.54 25.24C18.02 25.72 18.78 25.72 19.26 25.24L27.78 16.52C28.22 16.04 28.22 15.24 27.74 14.76Z",
    fill: "#01AC47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucess);
export default __webpack_public_path__ + "static/media/sucess.6e3d6375023611610833a1c1bff1fb12.svg";
export { ForwardRef as ReactComponent };